import {rootState} from '@mintdata-wsp/common/state/RootState';
import {observer} from 'mobx-react';
import * as React from 'react';

enum GuidelinesType
{
    oldStyle,
    newStyle2px,
    newStyle2pxWithOpacity,
}

@observer
export class SurfaceGuidelines extends React.Component<any, any>
{
    // public static guidelinesType:GuidelinesType = GuidelinesType.oldStyle;
    // public static guidelinesType:GuidelinesType = GuidelinesType.newStyle2px;
    public static guidelinesType:GuidelinesType = GuidelinesType.newStyle2pxWithOpacity;

    public static guidelineWidth:number = SurfaceGuidelines.guidelinesType === GuidelinesType.oldStyle ? 1 : 2;
    public static guidelineOpacity:number = SurfaceGuidelines.guidelinesType === GuidelinesType.newStyle2pxWithOpacity ? .7 : 1;
    public static guidelineExtraTranslate:string = SurfaceGuidelines.guidelinesType === GuidelinesType.oldStyle ? '' : ' - 1px';

    public render():JSX.Element
    {
        const guidelines = rootState.ui.visualDesigner.surfaceEditor.area.guidelines;
        const {area: {zoom}} = rootState.ui.visualDesigner.surfaceEditor;

        if( !guidelines.length )
            return null;

        const delta = (zoom - 1) * 50;

        return (
            <div>
                {guidelines.map((guideline, index) =>
                {
                    const deltaX = guideline.width === 1 ? SurfaceGuidelines.guidelineExtraTranslate : '';
                    const deltaY = guideline.height === 1 ? SurfaceGuidelines.guidelineExtraTranslate : '';

                    return (
                        <div key={index} style={{
                            position: 'absolute',
                            zIndex: 1000,
                            background: '#dd80dd',
                            left: `${guideline.left}px`,
                            top: `${guideline.top}px`,
                            width: `${guideline.width === 1 ? SurfaceGuidelines.guidelineWidth : guideline.width * zoom}px`,
                            height: `${guideline.height === 1 ? SurfaceGuidelines.guidelineWidth : guideline.height * zoom}px`,
                            transform: `scale(${1 / zoom}) translate(calc(${-delta}%${deltaX}), calc(${-delta}%${deltaY}))`,
                            opacity: SurfaceGuidelines.guidelineOpacity,
                        }} />
                    );
                })
                }
            </div>
        );
    }
}
